import styled from "styled-components/macro";
import { Icon } from "assets/Icons_";
import {
  active_project,
  current_language,
  currentActiveProject,
  iso_free,
  iso_isrotating,
  params_query,
  turn_building,
  vis_list,
} from "state/store.global";

import { getFocus, useAtom, useGet } from "state/jotai";
import { useBreak } from "hooks/useBreak";
import { BREAK_ } from "constants";
import { _project } from "state/store.projects";
import { useNavigate } from "react-router-dom";
import { _bootstrap } from "state/store.bootstrap";

import { useMemo } from "react";
import { startTransition } from "react";

export const OverviewBack = () => {
  const navigateTo = useNavigate();

    // Atom reads (lightweight)
  const params          = useGet(params_query);
  const type            = getFocus(_bootstrap, "type");
  const currentLanguage = useAtom(current_language)[0];

  const setActiveProject = useAtom(currentActiveProject)[1];
  const { pin, pid }     = useGet(active_project);

  const buttonsLabel = 
    getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];

  const rmode             = useGet(iso_free);
  const setRmode          = useAtom(iso_free)[1];
  const setIsrotate       = useAtom(iso_isrotating)[1];
  const setIsTurnBuilding = useAtom(turn_building)[1];
  
  const isrotate = useGet(iso_isrotating);

  const [, setShowList] = useAtom(vis_list);

  const isMobile = useBreak("md_dn");

    // ⭐ Memoized label (smooth)
  const backLabel = useMemo(() => {
    const key = rmode ? "Tilbage" : "TilbageOversigt";
    return buttonsLabel.find((btn) => btn.UILabelProperty === key)?.Label;
  }, [buttonsLabel, rmode]);

    // ⭐ Batch updates → eliminate lag
  const click1 = () => {
        setShowList(false);

        // Delay heavy state update until after next 2 frames
      startTransition(() => {
            navigateTo(
              `/${currentLanguage}/isometry${params.length ? params : ""}`
            )
          setActiveProject("");
          });
  };

  const click2 = () => {
      setRmode(false);
      setIsrotate(false);
      setIsTurnBuilding(false);
  };

    // ⭐ Inline dynamic positional style (faster than styled-components props)
  const boxStyle = {
    top: 
      (pin > 0 || type === "mono") && rmode
        ? "15px"
        :  "16px",
    left: "14px",
  };

  return (
    <>
      {!rmode ? (
        <>
          {pin > 0 && (
            <Box
              className = "icon-hover-effect"
              onClick   = {click1}
              style     = {boxStyle}
            >
              <Icon
                icon  = "new_back_arrow"
                size  = {isMobile ? "18" : "18"}
                color = "#000"
              />
              <Text>{backLabel}</Text>
            </Box>
          )}
        </>
      ) : (
        <Box
          className = "icon-hover-effect"
          onClick   = {click2}
          style     = {boxStyle}
        >
          <Icon
            icon  = "new_back_arrow"
            size  = {isMobile ? "18" : "18"}
            color = "#000"
          />
          <Text>{backLabel}</Text>
        </Box>
      )}
    </>
  );
};

  // ---------------- styled components -------------------

const Text = styled.div`
  white-space: nowrap;
  font-size  : 16px;
  color      : #000;
`;

const Box = styled.div`
  cursor     : pointer;
  padding    : 8px;
  z-index    : 5;
  align-items: center;
  display    : flex;
  gap        : 5px;
  user-select: none;
  position   : absolute;

  background-color: #ffffffbf;
  border-radius   : 6px;

  ${BREAK_.md_up} {
    top : 28px !important;
    left: 48px !important;
  }
`;
